import { useState, useEffect, useContext} from 'react'
import { Link } from "react-router-dom";
import axios from 'axios'
import moment from 'moment'
import { toast } from 'react-toastify';
import {useLang} from '../components/LangProvider'
import {useDialog} from '../components/DialogProvider'
import {useAuth} from "../components/AuthProvider";

function Home() {

  const [events, setEvents] = useState([{"name": "Loading", "description": "Please wait", "id": "1"}])
  const {lang, t} = useLang()
  const openDialog = useDialog()
  const {auth} = useAuth()

  const pattern = {
    name: `.{2,}`,
    mail: `^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)`,
    telephone: `[+]{0,1}[0-9 \\-]{10,}`,
    club: `.{3,}`,
  }

  let headers = {accept: "application/json"}
  if (auth.isAuth) headers['authorization'] ='Bearer ' + auth.token

  useEffect(() => {
    axios
    .get(process.env.REACT_APP_BACKEND_EVENT_LIST,{
      headers,
      params:{
        visibility:0,
      }
    })
    .then(
      res=>{
        // console.log('index event list',res)
        setEvents(res.data)
      }
    )
    .catch((err) =>{
      console.log('event load error',err)
      // do something ?
    })
  },[])

  function handleResultQuery(e){
    e.preventDefault()
    toast.warn("Handling result query ...",{
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
      containerId:"app"
    })
    return null
  }

  function handleVolunteerForm(e){
    e.preventDefault()
    toast.warn("Handling volunteer form ...",{
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
      containerId:"app"
    })
    return null
  }

  function handleTeamRegistrationForm(e){
    e.preventDefault()
    toast.warn("Handling team registration ...",{
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
      containerId:"app"
    })
    return null
  }

  return <>
  <section className="home-face">
    <div className="home-face__container">
    <div className="left">
      <h1 className="left-border">{t(events[0].name)}</h1>
      <div className="description" dangerouslySetInnerHTML={{__html: t(events[0].description)}} />
      {/*<button className="button-red-dashed" onClick={() => openDialog("sign up",events[0])}>{lang["register"]}</button>*/}
      <Link to={"/event/" + events[0].id} className="button-red-dashed"> {lang["register"]} </Link>
    </div>
    <div className="right">

    {events.slice(0,2).map((event) => {
        return <div className="coming-event" key={event.id}>
          <div>
          <p className="date">{moment(event.date_start_at).format("DD/MM/YYYY")}</p>
          <a href={"/event/"+event.id} className="details">{lang["details"]}</a>
          </div>
          <div>
          <h3>{t(event.city)}</h3>
          <p className="name">{t(event.name)}</p>
          {/*<a href="#" onClick={() => openDialog("sign up",event)} className="register">{lang["register"]} →</a>*/}
            <a href={"/event/"+event.id} className="register">{lang["register"]} →</a>
          </div>
        </div>
      })}

      <a href="#coming-events" className="button-black-dashed">{lang["more starts"]}</a>
    </div>
    </div>
  </section>


  <section className="home-agenda">
    <div className="container">
      <h1 className="events">{lang["better living"]}</h1>
      <p className="title-description"></p>
      <div className="video">
        <iframe src={"https://www.youtube.com/embed/"+lang["video id"]} title={lang["video title"]} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
      </div>
      <br/>
      <div dangerouslySetInnerHTML={{__html: lang["video text below"]}} />
    </div>
  </section>


  <section className="home-coming-events">
    <div className="container">
      <h1 className="events" id="coming-events" dangerouslySetInnerHTML={{__html: lang["events this year"]}} />
      <p className="title-description">{lang["events this year description"]}</p>
      <div className="event-cards">

        {events ? events.map((event) =>{
          return <div className="event-card" key={event.id}>
            <h3>{t(event.city)}</h3>
            <p className="name">{t(event.name)}</p>
            <p className="date">{moment(event.date_start_at).format("DD/MM/YYYY")}</p>
            <div style={{backgroundImage : `url('${event.small_image}')`}}>
              <Link to={"/event/" + event.id} className="button-teal" >{lang["register"]}</Link>
              <a className="details" href={"/event/" + event.id}>{lang["details"]}</a>
            </div>
          </div>
        }) : null}

      </div>
    </div>
  </section>


  <section className="home-results">
    <div className="container">
    <h1 className="events">{lang["results title"]}</h1>
    <p className="title-description">{lang["results description"]}</p>
    <div className="home-columns">
      <form className="home-form" action="">
      <h3>{lang["results form title"]}</h3>
      <input type="text" name="results" id="results-text" />
      <select name="results" id="results-race" placeholder="Select start">
        <option hidden disabled defaultValue value>{lang["results form select placeholder"]}</option>
        {/* TODO: result list here */}
        <option value="74">Kyiv</option>
        <option value="73">Kharkiv</option>
        <option value="72">Odesa</option>
        <option value="71">Lviv</option>
        <option value="70">Dnipro</option>
      </select>
      <button className="button-teal-dashed" onClick={(e) => handleResultQuery(e)}>{lang["results form submit"]}</button>
      </form>
      <div className="home-results__descr" dangerouslySetInnerHTML={{__html: lang["results article"]}} />
    </div>
    </div>
  </section>


  <section className="home-volunteering">
    <div className="container">
      <h1 className="events">{lang["volunteer title"]}</h1>
      <p className="title-description">{lang["volunteer description"]}</p>
      <form className="home-form" action="">
        <h2>{lang["volunteer form title"]}</h2>
        <input type="text" name="volunteer" id="volunteer-name"  placeholder={lang["volunteer form name"]} pattern={pattern.name}/>
        <input type="tel" name="volunteer" id="volunteer-tel" placeholder={lang["volunteer form tel"]} pattern={pattern.telephone}/>
        <input type="email" name="volunteer" id="volunteer-mail" placeholder={lang["volunteer form mail"]} pattern={pattern.mail}/>
        <select name="volunteer" id="volunteer-event" >
          <option hidden disabled defaultValue value>{lang["volunteer form select placeholder"]}</option>
          {events.map(event => {
            return <option value={event.id} key={"volunteer-to-"+event.id}>{t(event.name)}</option>
          })}
        </select>
        <button className="button-red-dashed" onClick={(e) => handleVolunteerForm(e)}>{lang["volunteer form submit"]}</button>
      </form>
    </div>
  </section>


  <section className="home-team-reg">
    <div className="container">
      <h1 className="events">{lang["team run title"]}</h1>
      <p className="title-description">{lang["team run description"]}</p>
      <form className="home-form" action="">
        <h2>{lang["team run form"]}</h2>
        <input type="text" name="team" id="team-name" placeholder={lang["team run form team name"]} pattern={pattern.name}/>
        <input type="text" name="team" id="team-contact" placeholder={lang["team run form name"]} pattern={pattern.name}/>
        <input type="tel" name="team" id="team-tel" placeholder={lang["team run form tel"]} pattern={pattern.telephone}/>
        <input type="email" name="team" id="team-mail" placeholder={lang["team run form mail"]} pattern={pattern.mail}/>
        <button className="button-red-dashed" onClick={(e) => handleTeamRegistrationForm(e)}>{lang["team run form submit"]}</button>
      </form>
    </div>
  </section>


  <section className="home-partners">
    <div className="container">
      <div className="partners-gallery">

      </div>
      <button className="button-transparent-dashed">{lang["button join as a partner"]}</button>
    {/* TODO: carousel with partners */}
    </div>
  </section>
  </>
}

export default Home